module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[108]351.d679978.woff2";